/**
 * MarketingColorModeToggle.jsx — compact light/dark control for marketing chrome.
 * Shaped by: md3c sibling look-and-feel; shared FusionMSI / md3c palette.
 * Invariants: uses the same app.colorMode persistence as AppColorModeToggle.
 * Colors come from createAppTheme light/dark only — no host-specific palette.
 * Related: FusionMsiMarketingNav.jsx, hooks/useAppColorMode.js, theme/appColorMode.js.
 */
import React from 'react';
import { IconButton, Tooltip } from '@mui/material';
import DarkModeOutlinedIcon from '@mui/icons-material/DarkModeOutlined';
import LightModeOutlinedIcon from '@mui/icons-material/LightModeOutlined';
import useAppColorMode from 'hooks/useAppColorMode';

function MarketingColorModeToggle() {
  const { isDark, toggle } = useAppColorMode();

  return (
    <Tooltip title={isDark ? 'Switch to light mode' : 'Switch to dark mode'}>
      <IconButton
        size="small"
        onClick={toggle}
        aria-label={isDark ? 'Switch to light mode' : 'Switch to dark mode'}
        data-testid="marketing.colorMode.toggle"
        color="inherit"
      >
        {isDark ? <LightModeOutlinedIcon fontSize="small" /> : <DarkModeOutlinedIcon fontSize="small" />}
      </IconButton>
    </Tooltip>
  );
}

export default MarketingColorModeToggle;
